import { useEffect, useRef, useState } from 'react';
import { TimeFormat } from 'src/utils/TimeHelper';

interface CountdownProps {
  startFrom: number;
  stopAt?: number;
  interval?: number;
  decrementBy?: number;
  step?: (current: number) => void;
  onComplete?: () => void;
  isReverseCounter?: boolean;
  stopCountdown?: boolean;
  stepCalculator?: (current: number) => number;
  formatter?: string;
}

export const Countdown = (props: CountdownProps) => {
  const {
    startFrom = 0,
    stopAt = 0,
    interval = 1000,
    decrementBy = 1,
    step,
    stepCalculator,
    onComplete,
    isReverseCounter,
    stopCountdown = false,
    formatter = 'ss'
  } = props;
  const [ticker, setTicker] = useState(startFrom);
  const intervalRef = useRef<NodeJS.Timeout>();
  useEffect(() => {
    const tick = () => {
      let newTickerValue;
      if (typeof stepCalculator === 'function') {
        newTickerValue = stepCalculator(ticker);
      } else {
        newTickerValue = ticker - decrementBy;
      }

      const stop = !isReverseCounter && newTickerValue < stopAt;
      if (stopCountdown || stop) {
        clearTimeout(intervalRef.current);
        onComplete && onComplete();
        step && step(ticker);
        return;
      }

      step && step(newTickerValue);
      setTicker(newTickerValue);
    };

    clearTimeout(intervalRef.current);
    intervalRef.current = setTimeout(tick, interval);

    return () => clearTimeout(intervalRef.current);
  }, [ticker]);

  const counter = TimeFormat(ticker, formatter);
  return <>{counter}</>;
};
